import { atom } from "jotai";

const teammatesAtom = atom<any[]>([]);
teammatesAtom.debugLabel = "Teammates";

export { teammatesAtom };
